(() => {
    const initNewsletterSuccessPopup = () => {
        const popup = document.querySelector('[data-newsletter-success-modal]');

        if (!popup) return;

        const overlay = document.querySelector('.background-overlay');
        const success = popup.querySelector('.success');
        const error = popup.querySelector('.error');
        const closeButton = popup.querySelector('[data-close-newsletter-success-modal]');
        const couponButton = popup.querySelector('[data-copy-newsletter-coupon]');
        const couponStatus = popup.querySelector('[data-newsletter-coupon-status]');

        const close = () => {
            popup.style.display = 'none';
            document.body.classList.remove('newsletter-success-show');
        };

        const open = (state = 'success') => {
            const isSuccess = state !== 'error';

            success.style.display = isSuccess ? 'block' : 'none';
            error.style.display = isSuccess ? 'none' : 'block';
            popup.style.display = 'flex';
            document.body.classList.add('newsletter-success-show');
        };

        const fallbackCopy = (code) => {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            const copied = document.execCommand('copy');
            input.remove();

            if (!copied) throw new Error('Copy command was unavailable.');
        };

        const copyCoupon = async () => {
            const code = couponButton.dataset.couponCode || couponButton.textContent.trim();

            try {
                if (navigator.clipboard && window.isSecureContext) {
                    try {
                        await navigator.clipboard.writeText(code);
                    } catch (clipboardError) {
                        fallbackCopy(code);
                    }
                } else {
                    fallbackCopy(code);
                }

                couponButton.classList.add('is-copied');
                couponStatus.textContent = 'Copied';
                window.setTimeout(() => couponButton.classList.remove('is-copied'), 1800);
            } catch (error) {
                couponStatus.textContent = 'Copy failed';
            }
        };

        window.HaloNewsletterSuccessPopup = { open, close };

        closeButton.addEventListener('click', close);
        overlay?.addEventListener('click', close);
        couponButton?.addEventListener('click', copyCoupon);
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && popup.style.display === 'flex') close();
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initNewsletterSuccessPopup);
    } else {
        initNewsletterSuccessPopup();
    }
})();
 